// extracted by mini-css-extract-plugin
export var layoutContainer = "_4e-0";
export var layoutContainerOpen = "_4e-5";
export var layoutContainerResizing = "_4e-1";
export var mainContent = "_4e-2";
export var resizeDivider = "_4e-3";
export var slidePanel = "_4e-4";